import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

interface Parameter {
    carouselId: string;
    productNumbers: string[];
    productId?: string;
    isShellEdit?: boolean;
}

interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
}

type HandlerType = Handler<Parameter, Props>;


export const LoadRelatedProducts: HandlerType = props => {
    const {
        parameter: { productNumbers },
    } = props;

    props.getProductCollectionParameter = { productNumbers, pageSize: 999 } as any;
};

export const LoadProducts: HandlerType = ({
    dispatch,
    getProductCollectionParameter,
    parameter: { carouselId, productId, isShellEdit, productNumbers },
}) => {
    if (!getProductCollectionParameter || !productNumbers || !productNumbers.length) {
        return false;
    }

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges")
        : (getProductCollectionParameter.expand = ["images", "badges"]);

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            excludeProductId: undefined,
            forceLoad: false,
            isShellEdit,
            showPriceAndInventory: true,
        } as any),
    );
};

export const chain = [LoadRelatedProducts, LoadProducts];

const loadRelatedProductsCarousel = createHandlerChainRunner(chain, "LoadRelatedProductsCarousel");
export default loadRelatedProductsCarousel;
